import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { CalendarEntry } from 'src/app/classes';
import { ITransactionSummaryView } from '../../../interfaces';
import { Step, StepStatus, STEP_FORM_GROUP } from '../../dialog/issue-transaction-dialog2/issue-transaction-dialog2-component-classes';

@Component({
  selector: 'app-make-appointment-form-summary',
  templateUrl: './make-appointment-form-summary.component.html',
  styleUrls: ['./make-appointment-form-summary.component.css']
})
export class MakeAppointmentFormSummaryComponent implements ITransactionSummaryView, OnInit {

  StepStatus = StepStatus;
  
  appointments: CalendarEntry[];

  constructor(
    @Inject(STEP_FORM_GROUP) public formGroup: FormGroup,
    @Inject('step') public step: Step
  ) { }

  ngOnInit(): void {
    this.validate();
  }

  validate(){
    this.appointments = this.appointmentsControl.value;
  }

  get appointmentsControl(): FormArray {
    return this.formGroup.controls['appointments'] as FormArray;
  }

}
